<template>
  <p class="small neutral-gray">{{ from }} - {{ to }} out of {{ totalItems }}</p>
</template>

<script lang="ts">
  export default {
    name: 'WTablePageIndex',
    props: {
      pageSize: { type: Number, required: true },
      pageNumber: { type: Number, required: true },
      totalItems: { type: Number, required: true },
    },

    computed: {
      itemsShown() {
        return Array(this.totalItems)
          .fill('__')
          .slice((this.pageNumber - 1) * this.pageSize, this.pageNumber * this.pageSize).length;
      },
      from() {
        return (this.pageNumber - 1) * this.pageSize + 1;
      },
      to() {
        return this.from + this.itemsShown - 1;
      },
    },
  };
</script>
